module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/cc-name-c9dee7d5015f6d1a5c3f8386a2e1115c.svg";